import React from "react";
import { Row, Col, Form, Modal } from "react-bootstrap";
import { GetJobList } from "../../services/JobService";
import { useState, useEffect, useRef, useMemo } from "react";
import { toast } from "react-toastify";
import { checkPermissionStatus } from "helpers/utils";
import { decryptDataFromArray } from "helpers/EncDec";
import Select from "react-select";
import api from "../../api";
import { Spinner } from "reactstrap";
import { fetchGenders, multiApplicationImport } from "helpers/backend_helper";
import Swal from "sweetalert2";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import serach_icon from "../../assets/images/icon/search-icon.svg";
import Dropdown from "react-bootstrap/Dropdown";
import threedots from "../../assets/images/icon/three-dots.svg";
import delete_ico from "../../assets/images/icon/delete_ico.svg";
import plus_icon from "../../assets/images/icon/plus.svg";
import { useTranslation } from "react-i18next";

const ImportResume = () => {
  const { t } = useTranslation();
  const history = useHistory();
  /** -------------------- PERMISSION (SAFE) -------------------- */
  // const hasViewPermission = useMemo(
  //   () => checkPermissionStatus("import-resume", "view"),
  //   []
  // );
  /** -------------------- STATES -------------------- */
  const [jobList, setJobList] = useState([]);
  const [selectedJob, setSelectedJob] = useState("");
  const [qualificationlist, setQualificationList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [resultData, setResultData] = useState([]);
  const [resultModal, setResultModal] = useState(false);
  const [multiUserData, setMultiUserData] = useState([]);
  const [genderData, setGenders] = useState([]);
  const [source, setSource] = useState("");
  const [skills, setSkills] = useState([""]);
  const [selectedUserCount, setSelecterUserCount] = useState(null);
  const [newSkill, setNewSkill] = useState("");
  const [isModalVisible, setModalVisible] = useState(false);
  const [isInputVisible, setInputVisible] = useState(false);
  const [query, setQuery] = useState("");

  /** -------------------- REFS -------------------- */
  const tableWrapperRef = useRef(null);
  const modalRef = useRef(null);

  /** -------------------- EFFECTS -------------------- */
  useEffect(() => {
    fetchJobList();
    fetchGenders().then(genders => setGenders(genders));
    getQualifications();
    document.title = "NeuroTal - Import Resumes";
  }, []);

  useEffect(() => {
    const handleClickOutside = event => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleCloseModal();
      }
    };

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  /** -------------------- API CALLS -------------------- */
  const fetchJobList = async () => {
    let language_id = localStorage.getItem("lang_id");
    if (language_id) {
      await GetJobList("approved")
        .then(res => {
          let responseData = res.data;
          responseData = decryptDataFromArray(responseData);
          if (responseData?.status) {
            let allJobs = responseData?.data?.map(el => ({
              ...el,
              label: el?.title,
              value: el?.id,
            }));
            setJobList(allJobs);
          }
        })
        .catch(err => {
          console.log(err);
          toast.error("No data Available");
        });
    }
  };

  const fetchQualifications = async () => {
    try {
      const lang_id = localStorage.getItem("lang_id") || 1;
      const response = await api({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}/masterdata/fetch-qualifications/${lang_id}`,
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response;
    } catch (err) {
      return err;
    }
  };

  const getQualifications = async () => {
    await fetchQualifications()
      .then(res => {
        setQualificationList(res?.data?.data);
      })
      .catch(err => {});
  };

  const handleInput = (key, value, count) => {
    let allUserData = multiUserData;
    allUserData = allUserData?.map(el => {
      if (el?.count === count) {
        return {
          ...el,
          [key]: value,
          errors: {
            ...el?.errors,
            [key]: "",
          },
        };
      }
      return el;
    });
    setMultiUserData(allUserData);
  };

  const handleMultiFileUpload = async e => {
    if (!selectedJob) {
      toast.error("Please select a position first!");
      e.target.value = "";
      return;
    }
    if (e.target.files?.length > 100) {
      toast.error("Max 100 files at a time can be selected.");
      e.target.value = "";
      return;
    }
    if (e.target.files?.length > 0) {
      const allowedFileTypes = [
        "application/msword",
        "application/pdf",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];
      setLoading(true);
      // let allUserData = multiUserData || [];
      // let allPromises = [];
      let allFiles = Array.from(e.target.files);
      let isError = false;
      // for (let element of e.target.files) {
      //   if (!allowedFileTypes.includes(element?.type)) {
      //     isError = true;
      //     break;
      //   }
      //   allPromises.push(handleFileUpload(element));
      // }
      allFiles.forEach(file => {
        if (!allowedFileTypes.includes(file?.type)) {
          isError = true;
        }
      });
      if (isError) {
        toast.error("Invalid file type. Please upload a DOC or PDF file.");
        setLoading(false);
        e.target.value = "";
        return;
      }
      try {
        const allUserData = await handleFileUpload(allFiles);

        let highestQualsNew = [];
        let existingQuals = qualificationlist?.map(el => el?.label);
        allUserData.forEach((el, index) => {
          if (
            el.highest_qualification &&
            !existingQuals?.includes(el?.highest_qualification)
          ) {
            highestQualsNew.push({
              label: el?.highest_qualification,
              value: el?.highest_qualification,
            });
          }
          el.count = index + 1;
        });
        setQualificationList([...qualificationlist, ...highestQualsNew]);
        setMultiUserData(allUserData);
        setLoading(false);
      } catch (err) {
        toast.error("Some error occured during upload");
        setLoading(false);
      }
    } else {
      toast.error("No Files Chosen");
    }
    e.target.value = "";
  };

  const handleSkillRemove = (skill, count) => {
    let allUserData = multiUserData;
    allUserData = allUserData?.map(el => {
      if (el?.count === count) {
        setSkills(el?.skills?.filter(item => item !== skill));
        return {
          ...el,
          skills: el?.skills?.filter(item => item !== skill),
        };
      }
      return el;
    });
    setMultiUserData(allUserData);
  };

  const handleAddSkill = count => {
    let allUserData = multiUserData;
    allUserData = allUserData?.map(el => {
      if (el?.count === count) {
        setSkills([...el?.skills, newSkill]);
        return {
          ...el,
          skills: [...el?.skills, newSkill],
        };
      }
      return el;
    });
    setNewSkill("");
    setMultiUserData(allUserData);
  };

  const handleFileUpload = async uploadFiles => {
    if (!Array.isArray(uploadFiles)) {
      uploadFiles = uploadFiles ? [uploadFiles] : [];
    }
    const newFormData = new FormData();
    uploadFiles.forEach(file => {
      newFormData.append("resume", file);
    });

    let userInfo = {};
    try {
      const response = await api(
        "https://recruit.itsneobot.com:8080/parse_resume",
        {
          method: "POST",
          data: newFormData,
          headers: {
            "Content-Type": "multipart/form-data", // Content type header
          },
        }
      );

      if (response?.status === 200) {
        let userDataList = response?.data?.results || [];
        userInfo = userDataList.map((userData, index) => ({
          name: userData?.name || "",
          mobile: (() => {
            let num = (userData?.mobile_number || "").replace(/[\s\-+]/g, "");
            if (num.length > 10) num = num.slice(-10);
            return num;
          })(),
          email_id: userData?.email || "",
          skills: userData?.skills || [],
          pharmacy_retail_experience: userData?.total_experience || 0,
          resume: uploadFiles[index] ? [uploadFiles[index]] : [],
          city: selectedJob?.city_id?.[0],
          highest_qualification: userData?.highest_qualification,
          // NEW FIELDS
          aadhaar_verified: false,
          bank_verified: false,
          background_verified: false,
          expected_salary: "",
          Previous_experience: userData?.experience,
          preferred_city: userData?.preferred_city,
          
        }));
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong.");
      // Handle error, if needed
    }
    return userInfo;
  };

  // if (!hasViewPermission) {
  //     return (
  //       <div className="page-content">
  //         <h4 className="text-center">Access Denied.</h4>
  //       </div>
  //     );
  //   }

  const renderCheck = item => {
    let searchableText = JSON.stringify(item)?.toLowerCase();
    if (searchableText?.includes(query?.toLowerCase())) {
      return true;
    }
    return false;
  };

  const handleRemoveUser = count => {
    let allUserData = multiUserData;
    allUserData = allUserData?.filter(el => el?.count !== count);
    setMultiUserData(allUserData);
  };
  const checkDuplicateEmailMobile = (users = []) => {
    const emailMap = {};
    const mobileMap = {};
    let hasDuplicate = false;

    // build maps
    users.forEach(user => {
      const email = user?.email_id?.trim()?.toLowerCase();
      const mobile = user?.mobile?.trim();

      if (email) {
        emailMap[email] = (emailMap[email] || 0) + 1;
      }
      if (mobile) {
        mobileMap[mobile] = (mobileMap[mobile] || 0) + 1;
      }
    });

    // update users
    const updatedUsers = users.map(user => {
      const email = user?.email_id?.trim()?.toLowerCase();
      const mobile = user?.mobile?.trim();

      let errors = { ...user.errors };

      // ✅ CLEAR previous duplicate errors FIRST
      if (errors?.email_id === "Duplicate Email ID found.") {
        delete errors.email_id;
      }
      if (errors?.mobile === "Duplicate Mobile Number found.") {
        delete errors.mobile;
      }

      // ❌ ADD only if duplicate exists
      if (email && emailMap[email] > 1) {
        errors.email_id = "Duplicate Email ID found.";
        hasDuplicate = true;
      }

      if (mobile && mobileMap[mobile] > 1) {
        errors.mobile = "Duplicate Mobile Number found.";
        hasDuplicate = true;
      }

      return { ...user, errors };
    });

    return { hasDuplicate, updatedUsers };
  };

  const handleSubmit = async () => {
    let isValid = true;

    let validiationData = multiUserData?.map(el => {
      let validationResult = validateForm(el);
      isValid = isValid && validationResult?.isValid;
      return validationResult;
    });

    if (!isValid) {
      let allUserData = multiUserData.map((el, index) => {
        if (!validiationData[index]?.isValid) {
          return {
            ...el,
            errors: {
              ...validiationData[index]?.newErrors,
            },
          };
        }
        return el;
      });

      setMultiUserData(allUserData);
      toast.error("Please fill all the required details.");
      return;
    }

    // 2️⃣ 🔥 DUPLICATE CHECK (Email + Mobile)
    const { hasDuplicate, updatedUsers } =
      checkDuplicateEmailMobile(multiUserData);

    if (hasDuplicate) {
      setMultiUserData(updatedUsers);
      toast.error("Duplicate Email or Mobile detected. Please fix.");
      return;
    }

    let messageText = `${multiUserData.length} Candidate(s) Data will be Submitted.`;

    Swal.fire({
      title: "Are you sure?",
      text: messageText,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Submit Details",
    }).then(async result => {
      if (!result.isConfirmed) return;

      try {
        setSubmitLoading(true);

        /** ✅ CREATE FORMDATA */
        const formData = new FormData();

        // normal fields
        formData.append("jobId", selectedJob?.id || "");
        formData.append("source", source || "");
        formData.append("applicationData", JSON.stringify(multiUserData));

        /** ✅ APPEND FILES CORRECTLY */
        multiUserData.forEach(user => {
          if (user?.resume?.length) {
            user.resume.forEach(file => {
              // backend expects: resume_<count>
              formData.append(`resume_${user.count}`, file);
            });
          }
        });

        const res = await multiApplicationImport(formData);

        let userResult = res?.resultData || [];
        setResultData(userResult);
        setResultModal(true);
        setMultiUserData([]);
        setSelectedJob("");

        toast.success("Import Process completed Successfully!");
      } catch (error) {
        toast.error(
          error?.response?.data?.message ||
            error?.message ||
            "Error while submission"
        );
      } finally {
        setSubmitLoading(false);
      }
    });
  };

  const validateForm = userData => {
    let isValid = true;
    let newErrors = {};
    const nameRegex = /^[A-Za-z.\s]+$/;

    const mobileRegex = /^[1-9][0-9]{9}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!userData?.name || !nameRegex.test(userData?.name)) {
      newErrors.name = "Valid User Name is required.";
      isValid = false;
    }
    if (
      !userData?.email_id?.trim() ||
      !emailRegex.test(userData?.email_id?.trim())
    ) {
      newErrors.email_id = "Valid Email ID is required.";
      isValid = false;
    }
    if (!userData?.mobile || !mobileRegex.test(userData?.mobile)) {
      newErrors.mobile = "Valid Mobile Number is required.";
      isValid = false;
    }
    // if (!userData?.gender) {
    //   newErrors.gender = "Gender is required.";
    //   isValid = false;
    // }
    if (!userData?.highest_qualification) {
      newErrors.highest_qualification = "Qualification is required.";
      isValid = false;
    }
    // if (!userData?.dob) {
    //     newErrors.dob = "DOB is required.";
    //     isValid = false;
    // }
    // if (!userData?.city) {
    //     newErrors.city = "Location is required.";
    //     isValid = false;
    // }
    // if (!userData?.pharmacy_retail_experience) {
    //     newErrors.pharmacy_retail_experience = "Relevant Experience is required.";
    //     isValid = false;
    // }
    // if (!userData?.job_portal_name) {
    //     newErrors.job_portal_name = "Job Portal is required.";
    //     isValid = false;
    // }
    return { isValid, newErrors };
  };

  const handleClick = () => {
    history.goBack(); // Navigate to the previous page
  };

  /**table arrow */

  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  //import-resume
  const [genders, setGenderss] = useState("");
  const handleGenderChange = e => {
    if (genders === e.target.name) {
      setGenderss("");
    } else {
      setGenderss(e.target.name);
    }
  };

  const handleInputChange = e => {
    setNewSkill(e.target.value);
  };

  const handleSubmitSkill = e => {
    e.preventDefault();
    if (newSkill.trim()) {
      setSkills([...skills, newSkill]);
      setNewSkill("");
      setModalVisible(false);
      setInputVisible(false); // Close the modal after adding
    }
  };

  const handleAddSkillClick = (skillList, ind) => {
    setSkills(skillList);
    setSelecterUserCount(ind);
    setModalVisible(true); // Show the modal
  };

  const handleCloseModal = () => {
    setModalVisible(false); // Close the modal
    setNewSkill(""); // Reset new skill input
  };

  const toggleInputVisibility = () => {
    setInputVisible(prev => !prev); // Toggle input visibility
  };

  const options = [
    { value: "option1", label: "Option 1" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];
  const [selectedOption, setSelectedOption] = useState(null);

  const handleChange = selectedOption => {
    setSelectedOption(selectedOption);
  };

  const handleDrop = e => {
    e.preventDefault();

    if (!loading) {
      const files = e.dataTransfer.files;
      handleMultiFileUpload({ target: { files } });
    }
  };

  return (
    <>
      <div className="pending-list-page feedbacks">
        <div className="joblist-container create-vacancy">
          <Row className="mb-3 align-items-center py-2 pt-0 depart-content">
            <Col lg="6" md="6">
              <Link to="/role-list">
                <h5 className="text-uppercase heading-one">
                  <img
                    src={arrow_btn}
                    alt="arrow_btn"
                    className="arrow-btn"
                    onClick={handleClick}
                  />
                  {t(`Bulk Import.Bulk Application Import`)}
                </h5>
              </Link>
            </Col>
          </Row>
        </div>

        <Col lg={12}>
          <div className="outerTab-box-wrapper below-vacancy">
            <div className="cards-section  cadidate-details import-resume-card">
              <h4> {t(`Bulk Import.Mass Resume Upload`)}</h4>

              <div className="total-serachbar  import-resumes">
                <div className="serach-bar-top">
                  <Form.Label className="float-label">
                    {t(`Bulk Import.Select Job Title / Designation`)}
                    <span class="text-danger">*</span>
                  </Form.Label>
                  <div
                    title={
                      selectedJob?.label ||
                      `${t(`Bulk Import.Select Job Title / Designation`)}`
                    }
                  >
                    <Select
                      id="job_title"
                      placeholder={t(
                        `Bulk Import.Select Job Title / Designation`
                      )}
                      name="job_title"
                      value={selectedJob}
                      options={jobList}
                      onChange={e => {
                        setSelectedJob(e);
                        setMultiUserData([]);
                      }}
                    />
                  </div>
                </div>

                <div className="serach-bar-top">
                  <Form.Label className="float-label">
                    {t(`Bulk Import.Source`)}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={source}
                    placeholder={t(`Bulk Import.Enter Source`)}
                    name="source"
                    onChange={e => setSource(e.target.value)}
                    title={t(`Bulk Import.Source`)}
                  />
                </div>

                <div className="serach-bar-top">
                  {/* <Form.Label className="float-label">
                    Source (Naukri)
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={source}
                    placeholder="Enter Source"
                    name="source"
                    onChange={e => setSource(e.target.value)}
                  /> */}
                </div>

                <div className="serach-bar-top">
                  {/* <Form.Label className="float-label">
                    Source (Other)
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={source}
                    placeholder="Enter Source"
                    name="source"
                    onChange={e => setSource(e.target.value)}
                  /> */}
                </div>
              </div>

              <div
                className="serach-bar-top upload-flies-create w-100"
                onDragOver={e => e.preventDefault()}
                onDrop={handleDrop}
              >
                <h4>{t(`Bulk Import.Upload bulk CV/Resume`)}</h4>
                {checkPermissionStatus("import-resume", "create") && (
                  <Form.Group className="floating-label">
                    <label
                      className="btn btn-sm btn-primary mb-0 d-flex"
                      style={{
                        opacity: selectedJob && !loading ? 1 : 0.5,
                      }}
                    >
                      {loading && <Spinner size={"sm"} className="mx-2" />}
                      {t(`Bulk Import.Choose File`)}
                      <input
                        type="file"
                        multiple
                        onChange={e => {
                          if (!loading) {
                            handleMultiFileUpload(e);
                          }
                        }}
                        accept=".pdf,.docx,.doc"
                        style={{ display: "none" }}
                        disabled={loading}
                      />
                    </label>
                  </Form.Group>
                )}

                <div className="upload-files-po">
                  <h5>{t(`Bulk Import.drop file`)}</h5>
                  <p>{t(`Bulk Import.File Type Allowed`)}</p>
                </div>
              </div>
              <p>{t(`Bulk Import.Note`)}</p>
            </div>

            {/* <div className="tabel-application pb-3 mb-3">
              <div className="table-data-search import-file-share">
                <div className="total-record">
                  <h5>Total Records:</h5>
                </div>
                <div className="total-serachbar  import-resumes">
                  <div className="serach-bar-top">
                    <Form.Label className="float-label">
                      Select Job Title / Designation
                    </Form.Label>
                    <Select
                      id="job_title"
                      placeholder="Select Job Title / Designation"
                      name="job_title"
                      value={selectedJob}
                      options={jobList}
                      onChange={e => {
                        setSelectedJob(e);
                        setMultiUserData([]);
                      }}
                    />
                  </div>

                  <div className="serach-bar-top">
                    <Form.Label className="float-label">
                      Source &nbsp;<small>(For Ex: LinkedIn etc.)</small>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={source}
                      placeholder="Enter Source"
                      name="source"
                      onChange={e => setSource(e.target.value)}
                    />
                  </div>

                  <div className="take-text filter">
                    {checkPermissionStatus("import-resume", "create") && (
                      <Form.Group className="floating-label">
                        <Form.Label className="float-label">
                          Import Resume
                        </Form.Label>
                        <div>
                          <label
                            className="btn btn-sm btn-primary mb-0 d-flex"
                            style={{
                              opacity: selectedJob && !loading ? 1 : 0.5,
                            }}
                          >
                            {loading && (
                              <Spinner size={"sm"} className="mx-2" />
                            )}
                            Import Resume
                            <input
                              type="file"
                              multiple
                              onChange={e => {
                                if (!loading) {
                                  handleMultiFileUpload(e);
                                }
                              }}
                              accept=".pdf,.docx,.doc"
                              style={{ display: "none" }}
                              disabled={loading}
                            />
                          </label>
                        </div>
                      </Form.Group>
                    )}
                  </div>

                  <div className="take-text filter">
                    {multiUserData?.length > 0 && (
                      <Form.Group className="floating-label">
                        <Form.Label className="float-label">
                          Submit Details
                        </Form.Label>
                        <div>
                          <label
                            className="btn btn-sm btn-primary mb-0 bg-success sucess-btn d-flex"
                            style={{ opacity: selectedJob ? 1 : 0.5 }}
                            onClick={() => {
                              if (!submitLoading) {
                                handleSubmit();
                              }
                            }}
                          >
                            {submitLoading && (
                              <Spinner size={"sm"} className="mx-2" />
                            )}
                            Submit
                          </label>
                        </div>
                      </Form.Group>
                    )}
                  </div>

                  <div className="tale-text right-panel d-flex">
                    <button
                      className="button left"
                      onClick={() => handleScroll("left")}
                    >
                      <img src={right_arrow} alt="right-arrow" />
                    </button>
                    <button
                      className="button right"
                      onClick={() => handleScroll("right")}
                    >
                      <img src={right_arrow} alt="right-arrow" />
                    </button>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="tabel-application pb-3 mb-3">
              <div className="total-serachbar  import-resumes justify-content-end">
                <div className="serach-bar-top">
                  <form class="form-inline">
                    <input
                      class="form-control mr-sm-2"
                      type="search"
                      placeholder={t(`Bulk Import.Search By`)}
                      aria-label="Search"
                      value={query}
                      onChange={e => setQuery(e.target.value)}
                    />
                    <span>
                      <img src={serach_icon} alt="search" />
                    </span>
                  </form>
                </div>

                <div className="take-text filter">
                  {multiUserData?.length > 0 && (
                    <Form.Group className="floating-label">
                      {/* <Form.Label className="float-label">
                        Submit Details
                      </Form.Label> */}
                      <div>
                        <label
                          className="btn btn-sm btn-primary mb-0 bg-success sucess-btn d-flex"
                          style={{ opacity: selectedJob ? 1 : 0.5 }}
                          onClick={() => {
                            if (!submitLoading) {
                              handleSubmit();
                            }
                          }}
                        >
                          {submitLoading && (
                            <Spinner size={"sm"} className="mx-2" />
                          )}
                          {t(`Bulk Import.Submit`)}
                        </label>
                      </div>
                    </Form.Group>
                  )}
                </div>

                <div className="tale-text right-panel d-flex ms-0">
                  <button
                    className="button left"
                    onClick={() => handleScroll("left")}
                    data-tooltip={t(`Bulk Import.Scroll Left`)}
                  >
                    <img src={right_arrow} alt="right-arrow" />
                  </button>
                  <button
                    className="button right"
                    onClick={() => handleScroll("right")}
                    data-tooltip={t(`Bulk Import.Scroll Right`)}
                  >
                    <img src={right_arrow} alt="right-arrow" />
                  </button>
                </div>
              </div>
            </div>

            <div className="timeto-hire-card userlist  importResume">
              <div className="table-custome-class range-custome">
                <div className="scroll-container">
                  {multiUserData?.length > 0 && (
                    <div className="table-wrapper" ref={tableWrapperRef}>
                      <div className="table-pending-list  ">
                        <div className="react-bootstrap-table table-wrapper">
                          {!submitLoading && (
                            <>
                              <table className="table table-hover table-bordered">
                                <thead>
                                  <tr>
                                    <th className="text-left">
                                      {t(`Bulk Import.Serial No`)}
                                    </th>
                                    <th className="text-left import-th name-id">
                                      {t(`Bulk Import.Name`)}
                                    </th>
                                    <th className="text-left import-th name-id">
                                      {t(`Bulk Import.Email`)}
                                    </th>
                                    <th className="text-left import-th">
                                      {t(`Bulk Import.Mobile Number`)}
                                    </th>
                                    <th className="text-left import-th gender-id">
                                      {t(`Bulk Import.Gender`)}
                                    </th>
                                    <th className="text-left import-th skill-id">
                                      {t(`Bulk Import.Skills`)}
                                    </th>
                                    <th className="text-left import-th">
                                      {t(`Bulk Import.Qualifications`)}
                                    </th>
                                    <th className="text-left import-th">
                                      {t(`Bulk Import.aadhar_verification`)}
                                    </th>
                                    <th className="text-left import-th">
                                      {t(`Bulk Import.bank_verification`)}
                                    </th>
                                    <th className="text-left import-th">
                                      {t(`Bulk Import.background_verification`)}
                                    </th>
                                    <th className="text-left import-th">
                                      {t(`Bulk Import.expected_salary`)}
                                    </th>
                                    <th className="text-left import-th actionss">
                                      {t(`Bulk Import.Actions`)}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {multiUserData
                                    ?.filter(renderCheck)
                                    ?.map((el, index) => {
                                      return (
                                        <tr key={el?.count}>
                                          <td className="text-left ">
                                            {index + 1}.
                                          </td>
                                          <td className="import-th name-id ">
                                            <Form.Control
                                              placeholder="Name"
                                              type="text"
                                              name="name"
                                              value={el?.name}
                                              onChange={e => {
                                                handleInput(
                                                  "name",
                                                  e.target.value,
                                                  el?.count
                                                );
                                              }}
                                            />
                                            {el?.errors?.name && (
                                              <p className="text-danger">
                                                {el?.errors?.name}
                                              </p>
                                            )}
                                          </td>
                                          <td className="import-th name-id">
                                            <Form.Control
                                              placeholder="Email ID"
                                              type="text"
                                              name="email_id"
                                              value={el?.email_id}
                                              onChange={e => {
                                                handleInput(
                                                  "email_id",
                                                  e.target.value,
                                                  el?.count
                                                );
                                              }}
                                            />
                                            {el?.errors?.email_id && (
                                              <p className="text-danger">
                                                {el?.errors?.email_id}
                                              </p>
                                            )}
                                          </td>
                                          <td className="import-th">
                                            <Form.Control
                                              placeholder="Enter Mobile "
                                              type="text"
                                              name="mobile"
                                              value={el?.mobile}
                                              onChange={e => {
                                                handleInput(
                                                  "mobile",
                                                  e.target.value,
                                                  el?.count
                                                );
                                              }}
                                            />
                                            {el?.errors?.mobile && (
                                              <p className="text-danger">
                                                {el?.errors?.mobile}
                                              </p>
                                            )}
                                          </td>
                                          <td className="import-th gender-id">
                                            <Select
                                              id="gender"
                                              placeholder="Gender"
                                              name="gender"
                                              value={genderData?.find(
                                                item => item?.id === el?.gender
                                              )}
                                              options={genderData}
                                              onChange={e => {
                                                handleInput(
                                                  "gender",
                                                  e?.id,
                                                  el?.count
                                                );
                                              }}
                                            />
                                            {el?.errors?.gender && (
                                              <p className="text-danger">
                                                {el?.errors?.gender}
                                              </p>
                                            )}
                                          </td>
                                          <td className="import-th skill-id">
                                            {/* <div className="selected-data-card length-selected-data  mb-4">
                                          {el?.skills?.map((item, ind) => {
                                            return (
                                              <div
                                                className="select-para"
                                                key={`${item}_${ind}`}
                                              >
                                                <p>
                                                  <span className="selected-tag text-capitalize">
                                                    {item}
                                                  </span>
                                                  <button
                                                    className="remove-tag-button"
                                                    onClick={() =>
                                                      handleSkillRemove(
                                                        item,
                                                        el?.count
                                                      )
                                                    }
                                                  >
                                                    &times;
                                                  </button>
                                                </p>
                                              </div>
                                            );
                                          })}
                                          <div className="d-flex gap-2 align-items-center">
                                            <Form.Control
                                              type="text"
                                              name="skillText"
                                              value={el?.skillText}
                                              placeholder="Add Skill"
                                              onChange={e => {
                                                handleInput(
                                                  "skillText",
                                                  e?.target?.value,
                                                  el?.count
                                                );
                                              }}
                                            />
                                            <FontAwesomeIcon
                                              icon={faAdd}
                                              title="Add User"
                                              color="blue"
                                              className="font-size-18"
                                              style={{ cursor: "pointer" }}
                                              onClick={() =>
                                                handleAddSkill(el?.count)
                                              }
                                            />
                                          </div>
                                        </div> */}

                                            <div className="selected-data-card length-selected-data">
                                              <div className="select-data-row">
                                                {el?.skills?.length > 0 && (
                                                  <div className="select-para">
                                                    <p>
                                                      <span
                                                        onClick={() => {
                                                          handleAddSkillClick(
                                                            el?.skills,
                                                            el?.count
                                                          );
                                                        }}
                                                        className="selected-tag text-capitalize"
                                                      >
                                                        {el?.skills?.[0]}{" "}
                                                      </span>
                                                      <button
                                                        className="remove-tag-button"
                                                        onClick={() =>
                                                          handleSkillRemove(
                                                            el?.skills?.[0],
                                                            el?.count
                                                          )
                                                        }
                                                      >
                                                        &times;
                                                      </button>
                                                    </p>
                                                  </div>
                                                )}
                                                <div
                                                  className="row-one-skill"
                                                  onClick={() => {
                                                    handleAddSkillClick(
                                                      el?.skills,
                                                      el?.count
                                                    );
                                                  }}
                                                >
                                                  <img src={plus_icon} alt="" />{" "}
                                                  {el?.skills?.length - 1}
                                                </div>
                                              </div>

                                              {isModalVisible &&
                                                el?.count ===
                                                  selectedUserCount && (
                                                  <div className="custom-modal">
                                                    <div
                                                      className="modal-content"
                                                      ref={modalRef}
                                                    >
                                                      <div className="modal-header-list">
                                                        {skills.map(
                                                          (skill, index) => (
                                                            <div
                                                              className="select-para"
                                                              key={index}
                                                            >
                                                              <p>
                                                                <span className="selected-tag text-capitalize">
                                                                  {skill}
                                                                </span>
                                                                <button
                                                                  className="remove-tag-button"
                                                                  onClick={() =>
                                                                    handleSkillRemove(
                                                                      skill,
                                                                      el?.count
                                                                    )
                                                                  }
                                                                >
                                                                  &times;
                                                                </button>
                                                              </p>
                                                            </div>
                                                          )
                                                        )}
                                                      </div>
                                                      {isInputVisible ? (
                                                        <form
                                                          onSubmit={e => {
                                                            e.preventDefault();
                                                            handleAddSkill(
                                                              el?.count
                                                            );
                                                          }}
                                                          className="d-flex"
                                                        >
                                                          <input
                                                            type="text"
                                                            placeholder="Enter skill"
                                                            value={newSkill}
                                                            onChange={
                                                              handleInputChange
                                                            }
                                                            required
                                                          />
                                                        </form>
                                                      ) : (
                                                        <div>
                                                          <button
                                                            className="btn btn-primary mt-0"
                                                            onClick={
                                                              toggleInputVisibility
                                                            }
                                                          >
                                                            <img
                                                              src={plus_icon}
                                                              alt=""
                                                            />
                                                            Add Skill
                                                          </button>
                                                        </div>
                                                      )}
                                                    </div>
                                                  </div>
                                                )}
                                            </div>
                                          </td>
                                          <td className="import-th">
                                            <Select
                                              id="highest_qualification"
                                              placeholder="Select Qualification"
                                              name="highest_qualification"
                                              value={qualificationlist?.find(
                                                item =>
                                                  item?.value ===
                                                  el?.highest_qualification
                                              )}
                                              options={qualificationlist}
                                              onChange={e => {
                                                handleInput(
                                                  "highest_qualification",
                                                  e?.value,
                                                  el?.count
                                                );
                                              }}
                                            />
                                            {el?.errors
                                              ?.highest_qualification && (
                                              <p className="text-danger">
                                                {
                                                  el?.errors
                                                    ?.highest_qualification
                                                }
                                              </p>
                                            )}
                                          </td>

                                          {/* KYC Verification */}
                                          <td className="import-th">
                                            <div className="d-flex justify-content-center">
                                              <Form.Check
                                                type="switch"
                                                id={`aadhaar-${el?.count}`}
                                                checked={
                                                  el?.aadhaar_verified || false
                                                }
                                                onChange={e =>
                                                  handleInput(
                                                    "aadhaar_verified",
                                                    e.target.checked,
                                                    el?.count
                                                  )
                                                }
                                              />
                                            </div>
                                          </td>
                                          <td className="import-th">
                                            <div className="d-flex justify-content-center">
                                              <Form.Check
                                                type="switch"
                                                id={`bank-${el?.count}`}
                                                checked={
                                                  el?.bank_verified || false
                                                }
                                                onChange={e =>
                                                  handleInput(
                                                    "bank_verified",
                                                    e.target.checked,
                                                    el?.count
                                                  )
                                                }
                                              />
                                            </div>
                                          </td>

                                          {/* Background Verification */}
                                          <td className="import-th">
                                            <div className="d-flex justify-content-center">
                                              <Form.Check
                                                type="switch"
                                                id={`bgv-${el?.count}`}
                                                checked={
                                                  el?.background_verified ||
                                                  false
                                                }
                                                onChange={e =>
                                                  handleInput(
                                                    "background_verified",
                                                    e.target.checked,
                                                    el?.count
                                                  )
                                                }
                                              />
                                            </div>
                                          </td>

                                          {/* Expected Salary */}
                                          <td className="import-th">
                                            <Form.Control
                                              type="number"
                                              placeholder="Expected Salary"
                                              value={el?.expected_salary || ""}
                                              onChange={e =>
                                                handleInput(
                                                  "expected_salary",
                                                  e.target.value,
                                                  el?.count
                                                )
                                              }
                                            />
                                          </td>
                                          <td className="text-center import-th actionss">
                                            <div className="d-flex gap-2 align-items-center">
                                              {/* <div className="action-one small-img">
                                           
                                          </div> */}

                                              <div className="action-one filter therdosts">
                                                <Dropdown>
                                                  <Dropdown.Toggle
                                                    variant="success"
                                                    id="dropdown-basic"
                                                  >
                                                    <img
                                                      src={threedots}
                                                      alt=""
                                                      className="w-auto"
                                                    />
                                                  </Dropdown.Toggle>
                                                  <Dropdown.Menu>
                                                    <Dropdown.Item>
                                                      <div
                                                        className="text-success d-flex"
                                                        onClick={() =>
                                                          handleRemoveUser(
                                                            el?.count
                                                          )
                                                        }
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                        title="Delete Job"
                                                      >
                                                        <img
                                                          src={delete_ico}
                                                          alt="delete_icon"
                                                        />
                                                        <p>Delete</p>
                                                      </div>
                                                    </Dropdown.Item>
                                                  </Dropdown.Menu>
                                                </Dropdown>
                                              </div>
                                            </div>
                                          </td>
                                        </tr>
                                      );
                                    })}
                                </tbody>
                              </table>
                              {multiUserData?.length === 0 && (
                                <div className="no-data data-available">
                                  <img
                                    src="../img/data-not-available.png"
                                    alt="data not availble"
                                  />
                                  <h3>
                                    {t(
                                      `Bulk Import.Select Job & Import Resume`
                                    )}
                                  </h3>
                                  <p>{t(`Bulk Import.No Item Found`)}</p>
                                </div>
                              )}
                            </>
                          )}
                          {submitLoading && (
                            <div className="text-center p-3 m-3 ">
                              <Spinner size={"lg"} />
                              <div>Loading...</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {multiUserData?.length === 0 && (
                    <div className="no-data data-available">
                      <img
                        src="../img/data-not-available.png"
                        alt="data not availble"
                      />
                      <h3>{t(`Bulk Import.Select Job & Import Resume`)}</h3>
                      <p>{t(`Bulk Import.No Item Found`)}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Col>

        <Modal
          size="lg"
          show={resultModal}
          onHide={() => {
            setResultModal(false);
            setResultData([]);
          }}
          className="edit-modal-card asseentModal  import-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>Import Summary</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <table className="table table-bordered table-responisve">
                <thead>
                  <tr>
                    <th className="text-left appl-no">Appl. No</th>
                    <th className="text-center">Name</th>
                    <th className="text-left">Email Id</th>
                    <th className="text-center">Status</th>
                    <th className="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {resultData?.map((el, index) => {
                    return (
                      <tr key={index}>
                        <td className="text-left appl-no">{el?.appl_id}</td>
                        <td className="text-center">{el?.name}</td>
                        <td className="text-left">{el?.email_id}</td>
                        <td className="text-center">
                          {el?.success ? (
                            <span className="text-success">
                              Application Successfully Submitted
                            </span>
                          ) : (
                            <span className="text-danger">
                              Submission Failed <br /> [{el?.reason}]
                            </span>
                          )}
                        </td>
                        <td className="text-center">
                          {el?.appl_id ? (
                            <Link
                              to={
                                "candidate_consolidate/view-details/" +
                                el?.appl_id
                              }
                            >
                              View Details
                            </Link>
                          ) : (
                            "No Actions Available."
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default ImportResume;
